import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useStProject(projectId) {
    const {data, mutate, error} = useSWR(`${API_PROJECTS}/${projectId}`)
    return {
        stProject: data,
        mutateStProject: mutate,
        isLoadingStProject: !error && !data,
        isErrorStProject: error
    }
}